import { useAuth } from "react-oidc-context";
import { RouterProvider } from "@tanstack/react-router";
import { useCallback, useLayoutEffect, useRef } from "react";

import { router } from "./router";

export const EacdRouterProvider = () => {
  const auth = useAuth();
  const authRef = useRef(auth);
  authRef.current = auth;
  const getAuth = useCallback(() => authRef.current, []);

  useLayoutEffect(() => {
    void router.invalidate();
  }, [auth.isAuthenticated, auth.isLoading, auth.activeNavigator, auth.user?.access_token, auth.error]);

  return <RouterProvider router={router} context={{ getAuth }} />;
};
